import ClinicAddresses from './ClinicAddresses';
export default ClinicAddresses;
